import { useCurrencies } from 'contexts/hooks/useCurrencies'
import { getCurrencySymbol } from 'utils/currencies'

interface Props {
  currency?: string
}

export function CurrencySymbol({ currency }: Props) {
  const { userCurrency } = useCurrencies()
  const _currency = currency || userCurrency

  return getCurrencySymbol(_currency)
}
